import { RequestStatus } from '../../../../models';
import type RecentAssignmentsState from '../RecentAssignmentsState';

const INITIAL_STATE: RecentAssignmentsState = {
  certificationsStatus: RequestStatus.Idle,
  requestsStatus: RequestStatus.Idle,
};

export default INITIAL_STATE;
